import {
  BG_03,
  BENTO_GRID_DEFAULTS,
  hideBG03Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

const CARD_FIELDS = {
  cardIcon: {
    type: "imageUrl",
  },
  cardIconAlt: {
    type: "string",
  },
  cardTitle: {
    type: "string",
  },
  cardDescription: {
    type: "string",
  },
  cardLinkText: {
    type: "string",
  },
  cardLinkUrl: {
    type: "string",
  },
};

const createCardProp = (cardIndex, description) => ({
  type: "object",
  fields: CARD_FIELDS,
  defaultValue: BENTO_GRID_DEFAULTS[BG_03].cards[cardIndex],
  description: `${description} (BG03 only)`,
  hidden: hideBG03Props,
});

export const BG03_PLASMIC_PROPS = {
  bg03Heading: {
    type: "string",
    defaultValue: BENTO_GRID_DEFAULTS[BG_03].heading,
    description: "Section heading text (BG03 only)",
    hidden: hideBG03Props,
  },
  bg03Card1: createCardProp(0, "Feature card 1"),
  bg03Card2: createCardProp(1, "Feature card 2"),
  bg03Card3: createCardProp(2, "Feature card 3"),
  bg03Card4: createCardProp(3, "Feature card 4"),
};
